<odx-inline-message variant="default">
  <span i18n="@@refreshProducts.hint.productTypeNotFound">{{ dataType }} nicht gefunden?</span>
  <a odxLink (click)="onClickRefresh()" i18n="@@refreshProducts.hint.refreshProductData">Aktualisieren Sie die Produktdaten.</a>
</odx-inline-message>
